export const TIRES_AVAILABLE = 'Tires available'
export const SHOP_NOW = 'Shop Now'
